import React, { useCallback, useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import {
  isMobile,
  popupStore,
  ContentLoader,
  applicationStore,
  PlatformMessagesWrapper,
  UnderMaintenanceContainer,
  PostMessageListenerMessages,
  GameLaunchManager,
} from '@pascal/pascal-core';

import { RoutePaths } from './enums';
import { doBetsStore, roundsInfoStore } from './store';
import { gameLiveConnection } from './services';
import { MobileMainWrapper, WebMainWrapper } from './conatiners';
import { Factory, FactoryRouter, SocketConnection } from './core';
import gameLogo from './assets/images/game/fastTradeLogo-dark.png';

let timeoutId;

const App = observer(() => {
  const { isTabVisibility, setIsTabVisibility } = roundsInfoStore;
  const { connectionError } = popupStore;

  const components = useMemo(
    () => [
      {
        path: RoutePaths.game,
        element: (
          <UnderMaintenanceContainer>
            {isMobile() ? <MobileMainWrapper /> : <WebMainWrapper />}
          </UnderMaintenanceContainer>
        ),
        defaultRedirectComponent: true,
      },
      {
        path: RoutePaths.replay,
        element: (
          <UnderMaintenanceContainer>
            {isMobile() ? <MobileMainWrapper /> : <WebMainWrapper />}
          </UnderMaintenanceContainer>
        ),
      },
    ],
    []
  );

  const lostInternetConnection = useCallback(() => {
    popupStore.toggleReconnect(true);
    timeoutId = setTimeout(() => {
      popupStore.toggleReconnect(false);
      popupStore.onConnectionError(true);
      gameLiveConnection.stop();
    }, 5000);
  }, []);

  const reconnectInternet = useCallback(() => {
    if (!connectionError) {
      clearTimeout(timeoutId);
      popupStore.toggleReconnect(false);
    }
  }, [connectionError]);

  const visibilityChangeHandler = useCallback(() => {
    if (document.hidden) {
      setIsTabVisibility(false);
    } else {
      gameLiveConnection.sendGameGetInitialState(false);
      setTimeout(() => {
        setIsTabVisibility(true);
      }, 1000);
    }
  }, [setIsTabVisibility]);

  useEffect(() => {
    document.addEventListener('visibilitychange', visibilityChangeHandler);

    return () => {
      document.removeEventListener('visibilitychange', visibilityChangeHandler);
    };
  }, [visibilityChangeHandler]);

  // const lostInternetConnection = useCallback(() => {
  //   popupStore.onConnectionError(true);
  // }, []);
  //
  // const reconnectInternet = useCallback(() => {
  //   gameService.socketRecursiveReconnecting();
  // }, []);

  useEffect(() => {
    window.addEventListener('offline', lostInternetConnection);
    window.addEventListener('online', reconnectInternet);
    return () => {
      window.removeEventListener('offline', lostInternetConnection);
      window.removeEventListener('online', reconnectInternet);
    };
  }, [lostInternetConnection, reconnectInternet]);

  useEffect(() => {
    applicationStore.setIsBogLine(true);
    const intervalId = setInterval(() => {
      gameLiveConnection.sendPing();
    }, 3000);

    return () => {
      intervalId && clearInterval(intervalId);
    };
  }, []);

  return (
    <Factory>
      {!isTabVisibility && <ContentLoader isFull={true} logoSrc={gameLogo} />}
      <PlatformMessagesWrapper
        additionalMessagesParams={[
          {
            name: PostMessageListenerMessages.UpdateBalance,
            callback: () => {
              gameLiveConnection.getBalance();
            },
          },
        ]}
      >
        <GameLaunchManager
          // socketEventsHandlerDelays={socketEventsHandlerDelays}
          callbackForRunningGame={doBetsStore.handleReplayGame}
          GameContainer={<FactoryRouter components={components} />}
          SocketConnectionWr={
            <SocketConnection>
              <FactoryRouter components={components} />
            </SocketConnection>
          }
        />
      </PlatformMessagesWrapper>
    </Factory>
  );
});

export default App;
